import { RE2JS } from 're2js';

import { resolveOverlappingRanges } from '@neptune/shared/common-util';

export type GroupRange = { start: number; end: number; color: string };

export function resolveOverlappingGroupsRanges(ranges: GroupRange[]): GroupRange[] {
  return resolveOverlappingRanges(ranges, (left, right) => left.color === right.color);
}

export function getGroupsRangesFor(
  rules: Array<RE2JS | null>,
  value: string,
): Record<string, Array<[number, number]>> {
  const result: Record<string, Array<[number, number]>> = {};

  for (const rule of rules) {
    if (!rule) {
      continue;
    }

    const matchedRanges = processWithRE2Regex(rule, value, ({ start, end }): [number, number] => [
      start,
      end,
    ]);

    for (const key in matchedRanges) {
      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(...matchedRanges[key]);
    }
  }

  return result;
}

export function getGroupsValuesFor(rules: RE2JS[], values: string): Record<string, string[]> {
  const result: Record<string, string[]> = {};

  for (const rule of rules) {
    const matchedValues = processWithRE2Regex(rule, values, ({ value }) => value);

    Object.assign(result, matchedValues);
  }

  for (const key in result) {
    result[key] = result[key].sort();
  }

  return result;
}

function processWithRE2Regex<T>(
  rule: RE2JS,
  value: string,
  callback: (params: { groupName: string; start: number; end: number; value: string }) => T,
): Record<string, T[]> {
  const result: Record<string, T[]> = {};

  const matcher = rule.matcher(value);

  while (matcher.find()) {
    for (const [groupName, groupIndex] of Object.entries<number>(matcher.namedGroups)) {
      const start = +matcher.start(groupIndex);
      const end = +matcher.end(groupIndex);

      if (start >= 0 && end >= 0 && start < end) {
        if (!result[groupName]) {
          result[groupName] = [];
        }

        result[groupName].push(
          callback({ groupName, start, end, value: matcher.group(groupName) }),
        );
      }
    }
  }

  return result;
}
